<div class="placeholder" [style.width]="width" [style.height]="height" [style.margin-top]="spacing"></div>
